var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtRow',{class:['footer-fixed-margin', ("footer-fixed-margin-" + _vm.fixedSize)]},[_c('OmtRow',_vm._b({class:[
      'fixed-button',
      _vm.useFooter ? 'fixed-button-with-footer' : 'fixed-button-without-footer',
      _vm.solidColor && 'fixed-button-solid'
    ],attrs:{"desktopStart":5,"desktopEnd":8}},'OmtRow',_vm.$attrs.fixed ? _vm.$attrs.fixed : {},false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }